"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.position = void 0;
var type_guard_1 = require("@webnuts/type-guard");
var measure_unit_1 = require("./measure-unit");
var pos = type_guard_1.enums(['fixed', 'static', 'absolute', 'relative', 'sticky']);
/**
 * @see <https://developer.mozilla.org/en-US/docs/Web/CSS/position>
 */
exports.position = type_guard_1.union([
    pos,
    type_guard_1.props({
        position: type_guard_1.optional(pos),
        top: type_guard_1.optional(measure_unit_1.measureUnit),
        bottom: type_guard_1.optional(measure_unit_1.measureUnit),
        left: type_guard_1.optional(measure_unit_1.measureUnit),
        right: type_guard_1.optional(measure_unit_1.measureUnit)
    })
]);
